import { Box, Grid, Typography, Card, CardContent, useTheme, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";
import { useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MedalIcon from "@mui/icons-material/EmojiEvents";
import BadgeIcon from "@mui/icons-material/Work";
import SchoolIcon from "@mui/icons-material/School";
import CodeIcon from "@mui/icons-material/Code";
import AssessmentIcon from "@mui/icons-material/Assessment";

const achievements = [
  { title: "Best Presenter Award", description: "At World Café organized in Kolkata.", link: "https://www.linkedin.com/posts/lakshay-rohilla-02a23a119_bestpresenter-teambuilding-grateful-activity-7131258492417425408-atbc?utm_source=share&utm_medium=member_desktop", icon: <MedalIcon /> },
  { title: "Stack Overflow Badges", description: "7 Gold Badges, 17 Silver Badges for popular contributions to the community.", link: "https://stackoverflow.com/users/16876542/lakshay-rohilla", icon: <BadgeIcon /> },
  { title: "Jawahar Lal Nehru Zonal Science Exhibition", description: "Secured 1st position for outstanding performance.", link: "https://example.com/exhibition", icon: <SchoolIcon /> },
  { title: "Android Application Development 'Pahal'", description: "Secured 2nd position for Developing Android Application.", link: "https://example.com/pahal", icon: <CodeIcon /> },
  { title: "Android Application Development 'Annapurna'", description: "Secured 3rd position for Developing Android Application.", link: "https://example.com/annapurna", icon: <CodeIcon /> },
  { title: "HackerRank SQL Assessment", description: "Cleared HackerRank SQL Assessment.", link: "https://www.linkedin.com/posts/lakshay-rohilla-02a23a119_hackerrank-skill-certificate-activity-6928366234409271296-dOKx?utm_source=share&utm_medium=member_desktop", icon: <AssessmentIcon /> }
];

export default function AchievementsSection({homePage, achievementsPage}) {
  const themeHook = useTheme();
  const isSmallScreen = useMediaQuery(themeHook.breakpoints.down("md"));
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <Grid container spacing={4} alignItems="center" sx={{  mt: isSmallScreen ? (achievementsPage ? 0 : 100) : 7, mb:isSmallScreen ? 12 : 11 }}>
      {homePage ? (
        // Center-aligned top section for homePage prop true
        <>
          <Grid item xs={12}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h3" fontWeight="bold" color="black">
                My
              </Typography>
              <Typography variant="h4" fontWeight="bold" color="orange">
                Achievements 
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} container spacing={2} justifyContent="center">
            {achievements.map((achievement, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <motion.div
                  whileHover={{ scale: 1.08 }}
                  whileTap={{ scale: 0.98 }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  onClick={() => window.location.href = achievement.link}
                >
                  <Card
                    sx={{
                      borderRadius: 8,
                      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                      p: 3,
                      background: 'linear-gradient(135deg, #f5f5f5, #ffffff)',
                      cursor: 'pointer',
                      transition: 'transform 0.3s, background-color 0.3s, box-shadow 0.3s ease-in-out',
                      border: '1px solid #ddd',
                      position: 'relative',
                    }}
                  >
                    <Box sx={{ position: 'absolute', top: 10, left: 10, color: '#3f51b5' }}>
                      {achievement.icon}
                    </Box>
                    <CardContent sx={{ paddingTop: '2rem' }}>
                      <Typography variant="h6" fontWeight="bold" color="text.primary" sx={{ fontSize: '1.2rem' }}>
                        {achievement.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" mt={1}>
                        {hoveredIndex === index ? (
                          <Box display="flex" alignItems="center">
                            <Typography variant="body1" fontWeight="bold" color="primary" sx={{ fontSize: '1.1rem' }}>
                              Explore
                            </Typography>
                            <ArrowForwardIcon sx={{ ml: 1, fontSize: '1.3rem', color: '#3f51b5' }} />
                          </Box>
                        ) : (
                          achievement.description
                        )}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </>
      ) : (
        // Horizontal layout for homePage prop false
        <>
          <Grid item xs={12} md={4}>
            <Typography variant="h3" fontWeight="bold" color="black">
              My
            </Typography>
            <Typography variant="h4" fontWeight="bold" color="orange">
              Achievements :
            </Typography>
          </Grid>
          <Grid item xs={12} md={8} container spacing={2}>
            {achievements.map((achievement, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <motion.div
                  whileHover={{ scale: 1.08 }}
                  whileTap={{ scale: 0.98 }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  onClick={() => window.location.href = achievement.link}
                >
                  <Card
                    sx={{
                      borderRadius: 8,
                      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                      p: 3,
                      background: 'linear-gradient(135deg, #f5f5f5, #ffffff)',
                      cursor: 'pointer',
                      transition: 'transform 0.3s, background-color 0.3s, box-shadow 0.3s ease-in-out',
                      border: '1px solid #ddd',
                      position: 'relative',
                    }}
                  >
                    <Box sx={{ position: 'absolute', top: 10, left: 10, color: '#3f51b5' }}>
                      {achievement.icon}
                    </Box>
                    <CardContent sx={{ paddingTop: '2rem' }}>
                      <Typography variant="h6" fontWeight="bold" color="text.primary" sx={{ fontSize: '1.2rem' }}>
                        {achievement.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" mt={1}>
                        {hoveredIndex === index ? (
                          <Box display="flex" alignItems="center">
                            <Typography variant="body1" fontWeight="bold" color="primary" sx={{ fontSize: '1.1rem' }}>
                              Explore
                            </Typography>
                            <ArrowForwardIcon sx={{ ml: 1, fontSize: '1.3rem', color: '#3f51b5' }} />
                          </Box>
                        ) : (
                          achievement.description
                        )}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Grid>
  );
}